import React, { Component } from 'react';
import Route from './router'
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import './App.css';
// import Home from './pages/home/home';

import { connect } from 'react-redux'


class App extends Component {

  
  render() {
    return (
      <div className='App' id="app">

        <ConfigProvider locale={zhCN}>
          <Route />
        </ConfigProvider>
      
      </div>
    );
  }
}

export default connect()(App);
